export default __webpack_public_path__ + "static/media/DSC_0919.c87f45de.JPG";